const { DateTime } = require('luxon');

export const formatDisplayDate = (dateVal) => {
    return dateVal ? DateTime.fromISO(dateVal).setLocale('en-GB').toFormat('dd-MM-yyyy') : '';
};

export const formatRequestDate = (dateVal) => {
    if (dateVal) {
        var date = new Date(dateVal);
        let year = date.getFullYear();
        let month = ('0' + (date.getMonth() + 1)).slice(-2);
        let day = ('0' + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    }
    return null;
};

export const formatDate = (dateVal) => {
    if (dateVal) {
        const fullDateVal = DateTime.fromFormat(dateVal, 'yyyy-MM-dd HH:mm:ss');
        const normalDate = DateTime.fromFormat(dateVal, 'yyyy-MM-dd');
        const fullISODateVal = DateTime.fromISO(dateVal);
        const validDate = fullDateVal.isValid ? fullDateVal : normalDate.isValid ? normalDate : fullISODateVal;
        return validDate.toFormat('dd-MM-yyyy');
    }
    return null;
};

export const formatCommentDate = (dateVal) => {
    if (dateVal) {
        const fullISODateVal = DateTime.fromISO(dateVal);
        return fullISODateVal.toFormat('EEE,  dd-MM-yyyy h:mm a');
    }
    return null;
};

export const formatDisplayDateToRequestDate = (dateVal) => {
    return dateVal ? DateTime.fromFormat(dateVal, 'dd-MM-yyyy').toFormat('yyyy-MM-dd') : null;
};

export const getDaysFromYearMonth = (year, month) => {
    const daysInMonth = DateTime.local(year, month).daysInMonth;
    const daysArray = Array.from({ length: daysInMonth }, (_, index) => index + 1);
    return daysArray;
};

export const addMonthsToDate = (date, months) => {
    const newDate = date && months ? DateTime.fromJSDate(date)?.plus({ months: months }) : null;
    return newDate?.toLocaleString();
};

export const localeToISODate = (dateVal) => {
    if (dateVal) {
        const parsedDate = DateTime.fromFormat(dateVal, 'dd/MM/yyyy');
        return parsedDate.toISO();
    }
    return null;
};
